/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Draft_TitleInputs */

const tr_landing_telegram_mock_draft_title = /** @type {(inputs: Landing_Telegram_Mock_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-FATURA TASLAĞI`)
};

const en_landing_telegram_mock_draft_title = /** @type {(inputs: Landing_Telegram_Mock_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-INVOICE DRAFT`)
};

const de_landing_telegram_mock_draft_title = /** @type {(inputs: Landing_Telegram_Mock_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-FATURA-ENTWURF`)
};

const ru_landing_telegram_mock_draft_title = /** @type {(inputs: Landing_Telegram_Mock_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЧЕРНОВИК E-FATURA`)
};

/**
* | output |
* | --- |
* | "E-INVOICE DRAFT" |
*
* @param {Landing_Telegram_Mock_Draft_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_draft_title = /** @type {((inputs?: Landing_Telegram_Mock_Draft_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Draft_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_draft_title(inputs)
	if (locale === "de") return de_landing_telegram_mock_draft_title(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_draft_title(inputs)
	return tr_landing_telegram_mock_draft_title(inputs)
});